import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
    static component = "notification"

    connect() {
        super.connect()

        const hidesSharedBackground = this.element.dataset.hidesSharedBackground === "true"

        // Enable the notification button in the native app
        this.send("connect", { hidesSharedBackground }, (message) => {
            if (message.data.notifications !== undefined) {
                this.handleNotificationsRequest()
            }
        })
    }

    handleNotificationsRequest() {
        window.Turbo.visit('/notifications')
    }
}
